import * as angular from 'angular'
import { routes } from './routes'
import { sidebarConfig } from "./sidebar-config";
import configureRoutes from '../../js/configure-routes'

import '../css-bootstrap-jquery-et-al'

import 'angular-animate'
import 'angular-aria'
import 'angular-ui-router'
import 'angular-input-masks'
import 'angular-route'
import 'angular-resource'
import 'angular-translate'
import 'angular-messages'
import 'angular-material'
import 'angular-local-storage'
import '../utils'
import '@adamantio/ada-angularjs-utils'
import { configureLocalStorage } from '../../js/configure-local-storage';
import { configureLanguage } from '../../js/configure-languages';
import { configureTheme } from '../../js/configure-theme';
import 'react-dom'


const requiredModules = ['ui.utils.masks', 'ngRoute', 'ui.router', 'pascalprecht.translate', 'ngMaterial', 'LocalStorageModule', 'idhaManagerSdk', 'idhaOrdersSdk', 'utils', 'ada-loading-bar', 'ada-dialogs', 'history', 'ada-back-button', 'idhaPackingSdk', 'idhaAccountsSdk', 'ngMessages']

try {
    angular.module('ngRaven')
    requiredModules.push('ngRaven')
} catch (error) {
    console.error('módulo raven não encontrado')
}

const loginModule = angular.module('login', requiredModules)

loginModule.constant('startRoute', 'modules-menu');

loginModule.config(['$stateProvider', '$locationProvider', 'localStorageServiceProvider', '$httpProvider', '$translateProvider', '$urlRouterProvider', '$mdThemingProvider', function ($stateProvider, $locationProvider, localStorageServiceProvider, $httpProvider, $translateProvider, $urlRouterProvider, $mdThemingProvider) {

    configureRoutes(routes, sidebarConfig, $stateProvider)

    configureTheme($mdThemingProvider)

    $urlRouterProvider.otherwise('/home')

    configureLocalStorage(localStorageServiceProvider)

    configureLanguage($translateProvider, 'pt_BR')

    configureInterceptors()

    function configureInterceptors() {
        $httpProvider.interceptors.push('ownerIdHttpInterceptor');
        $httpProvider.interceptors.push('authErrorInterceptor');
        $httpProvider.interceptors.push('appVersionInterceptor');
    }

    $locationProvider.hashPrefix('');

}])

loginModule.run(['$q', '$window', 'LinkActionsService', function ($q, $window, LinkActionsService) {
    window['Promise'] = $q;

    LinkActionsService.subscribe();
}])

export { loginModule }